export type WindowBounds = {
    screenX: number;
    screenY: number;
    width: number;
    height: number;
};

export enum WorkspaceWindowPanelType {
    mapLegend,
    eventList,
    fleetMonitor,
    airportMonitor,
    flightList,
    airportList,
    routeAnalyzer,
    airportSummary
}
